import { createElementVNode as _createElementVNode, openBlock as _openBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8b2744c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navigation" }
const _hoisted_2 = { class: "navigation__menu" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    color: "#181818",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M10 18L14 18",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M2.35139 13.2135C1.99837 10.9162 1.82186 9.76763 2.25617 8.74938C2.69047 7.73112 3.65403 7.03443 5.58114 5.64106L7.02099 4.6C9.41829 2.86667 10.6169 2 12 2C13.3831 2 14.5817 2.86667 16.979 4.6L18.4189 5.64106C20.346 7.03443 21.3095 7.73112 21.7438 8.74938C22.1781 9.76763 22.0016 10.9162 21.6486 13.2135L21.3476 15.1724C20.8471 18.4289 20.5969 20.0572 19.429 21.0286C18.2611 22 16.5537 22 13.1388 22H10.8612C7.44633 22 5.73891 22 4.571 21.0286C3.40309 20.0572 3.15287 18.4289 2.65243 15.1724L2.35139 13.2135Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linejoin": "round"
    })
  ])
], -1))
const _hoisted_4 = { class: "label" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    color: "#181818",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M13 7C13 9.20914 11.2091 11 9 11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3C11.2091 3 13 4.79086 13 7Z",
      stroke: "currentColor",
      "stroke-width": "1.5"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M15 11C17.2091 11 19 9.20914 19 7C19 4.79086 17.2091 3 15 3",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M11 14H7C4.23858 14 2 16.2386 2 19C2 20.1046 2.89543 21 4 21H14C15.1046 21 16 20.1046 16 19C16 16.2386 13.7614 14 11 14Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M17 14C19.7614 14 22 16.2386 22 19C22 20.1046 21.1046 21 20 21H18.5",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1))
const _hoisted_6 = { class: "label" }
const _hoisted_7 = { class: "separator" }
const _hoisted_8 = { class: "separator__title" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    color: "#181818",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M16 23V4L4 7.5L3 20.5L16 23Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M17.5 5.14833L16 4V23L21 21.5C21 18.8371 20.7998 16.178 20.4012 13.5451L19.1298 5.14833H17.5Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M13.0016 4.87502C13.0092 2.85785 12.239 1.26304 11.0023 1.02911C9.44084 0.73373 7.72699 2.71982 7.17435 5.46517C7.09535 5.85761 7.04435 6.24433 7.01953 6.61979",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M14.8665 4.33083C14.5732 3.14854 13.9527 2.31296 13.1092 2.14837C11.7258 1.8784 10.2195 3.50662 9.55469 5.8801",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M12.7896 9.42437C11.7896 9.0035 9.19076 8.24627 8.50372 10.266C8.1332 11.3553 8.79795 12.5183 10.2171 13.6331C12.2041 15.1939 11.867 16.524 11.5033 17.0001C10.2176 18.6837 7.64621 17.7016 6.78906 17.0001",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1))
const _hoisted_10 = { class: "label" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    color: "#181818",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M2.9668 10.4961V15.4979C2.9668 18.3273 2.9668 19.742 3.84548 20.621C4.72416 21.5001 6.13837 21.5001 8.9668 21.5001H14.9668C17.7952 21.5001 19.2094 21.5001 20.0881 20.621C20.9668 19.742 20.9668 18.3273 20.9668 15.4979V10.4961",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M14.9668 16.9932C14.2827 17.6004 13.1936 17.9932 11.9668 17.9932C10.74 17.9932 9.65089 17.6004 8.9668 16.9932",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M10.1038 8.41848C9.82182 9.43688 8.79628 11.1936 6.84777 11.4482C5.12733 11.673 3.82246 10.922 3.48916 10.608C3.12168 10.3534 2.28416 9.53872 2.07906 9.02952C1.87395 8.52032 2.11324 7.41706 2.28416 6.96726L2.96743 4.98888C3.13423 4.49196 3.5247 3.31666 3.92501 2.91913C4.32533 2.5216 5.13581 2.5043 5.4694 2.5043H12.4749C14.2781 2.52978 18.2209 2.48822 19.0003 2.50431C19.7797 2.52039 20.2481 3.17373 20.3848 3.45379C21.5477 6.27061 22 7.88382 22 8.57124C21.8482 9.30456 21.22 10.6873 19.0003 11.2955C16.6933 11.9275 15.3854 10.6981 14.9751 10.2261M9.15522 10.2261C9.47997 10.625 10.4987 11.4279 11.9754 11.4482C13.4522 11.4686 14.7273 10.4383 15.1802 9.92062C15.3084 9.76786 15.5853 9.31467 15.8725 8.41848",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1))
const _hoisted_12 = { class: "label" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    color: "#181818",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M7.83152 21.3478L7.31312 20.6576C6.85764 20.0511 5.89044 20.1 5.50569 20.7488C4.96572 21.6595 3.5 21.2966 3.5 20.2523V3.74775C3.5 2.7034 4.96572 2.3405 5.50569 3.25115C5.89044 3.90003 6.85764 3.94888 7.31312 3.34244L7.83152 2.65222C8.48467 1.78259 9.84866 1.78259 10.5018 2.65222L10.5833 2.76076C11.2764 3.68348 12.7236 3.68348 13.4167 2.76076L13.4982 2.65222C14.1513 1.78259 15.5153 1.78259 16.1685 2.65222L16.6869 3.34244C17.1424 3.94888 18.1096 3.90003 18.4943 3.25115C19.0343 2.3405 20.5 2.7034 20.5 3.74774V20.2523C20.5 21.2966 19.0343 21.6595 18.4943 20.7488C18.1096 20.1 17.1424 20.0511 16.6869 20.6576L16.1685 21.3478C15.5153 22.2174 14.1513 22.2174 13.4982 21.3478L13.4167 21.2392C12.7236 20.3165 11.2764 20.3165 10.5833 21.2392L10.5018 21.3478C9.84866 22.2174 8.48467 22.2174 7.83152 21.3478Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M15 9L9 15",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M15 15H14.991M9.00897 9H9",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1))
const _hoisted_14 = { class: "label" }
const _hoisted_15 = { class: "separator" }
const _hoisted_16 = { class: "separator__title" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    color: "#181818",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "10",
      stroke: "currentColor",
      "stroke-width": "1.5"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M9.5 16L9.5 8",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M11 8V6M13.5 8V6",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M11 18V16M13.5 18V16",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M9.5 12H14.5C15.3284 12 16 12.6716 16 13.5V14.5C16 15.3284 15.3284 16 14.5 16H8",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M8 8L14.5 8C15.3284 8 16 8.67157 16 9.5V10.5C16 11.3284 15.3284 12 14.5 12H9.5",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1))
const _hoisted_18 = { class: "label" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    color: "#181818",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M3 4.5C3 3.67157 3.67157 3 4.5 3H6.5C7.32843 3 8 3.67157 8 4.5V6.5C8 7.32843 7.32843 8 6.5 8H4.5C3.67157 8 3 7.32843 3 6.5V4.5Z",
      stroke: "currentColor",
      "stroke-width": "1.5"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M3 17.5C3 16.6716 3.67157 16 4.5 16H6.5C7.32843 16 8 16.6716 8 17.5V19.5C8 20.3284 7.32843 21 6.5 21H4.5C3.67157 21 3 20.3284 3 19.5V17.5Z",
      stroke: "currentColor",
      "stroke-width": "1.5"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M8.00002 18.5H21M16 5.5H8.00002M16.3235 7.67649L7.64868 16.3513",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M16 4.5C16 3.67157 16.6716 3 17.5 3H19.5C20.3284 3 21 3.67157 21 4.5V6.5C21 7.32843 20.3284 8 19.5 8H17.5C16.6716 8 16 7.32843 16 6.5V4.5Z",
      stroke: "currentColor",
      "stroke-width": "1.5"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M18 21L19.3883 20.0537C20.4628 19.3213 21 18.9551 21 18.5C21 18.0449 20.4628 17.6787 19.3883 16.9463L18 16",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1))
const _hoisted_20 = { class: "label" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    color: "#181818",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M10 18L14 18",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M2.35139 13.2135C1.99837 10.9162 1.82186 9.76763 2.25617 8.74938C2.69047 7.73112 3.65403 7.03443 5.58114 5.64106L7.02099 4.6C9.41829 2.86667 10.6169 2 12 2C13.3831 2 14.5817 2.86667 16.979 4.6L18.4189 5.64106C20.346 7.03443 21.3095 7.73112 21.7438 8.74938C22.1781 9.76763 22.0016 10.9162 21.6486 13.2135L21.3476 15.1724C20.8471 18.4289 20.5969 20.0572 19.429 21.0286C18.2611 22 16.5537 22 13.1388 22H10.8612C7.44633 22 5.73891 22 4.571 21.0286C3.40309 20.0572 3.15287 18.4289 2.65243 15.1724L2.35139 13.2135Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linejoin": "round"
    })
  ])
], -1))
const _hoisted_22 = { class: "label" }
const _hoisted_23 = { class: "separator" }
const _hoisted_24 = { class: "separator__title" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    color: "#181818",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M16 23V4L4 7.5L3 20.5L16 23Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M17.5 5.14833L16 4V23L21 21.5C21 18.8371 20.7998 16.178 20.4012 13.5451L19.1298 5.14833H17.5Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M13.0016 4.87502C13.0092 2.85785 12.239 1.26304 11.0023 1.02911C9.44084 0.73373 7.72699 2.71982 7.17435 5.46517C7.09535 5.85761 7.04435 6.24433 7.01953 6.61979",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M14.8665 4.33083C14.5732 3.14854 13.9527 2.31296 13.1092 2.14837C11.7258 1.8784 10.2195 3.50662 9.55469 5.8801",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M12.7896 9.42437C11.7896 9.0035 9.19076 8.24627 8.50372 10.266C8.1332 11.3553 8.79795 12.5183 10.2171 13.6331C12.2041 15.1939 11.867 16.524 11.5033 17.0001C10.2176 18.6837 7.64621 17.7016 6.78906 17.0001",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1))
const _hoisted_26 = { class: "label" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    color: "#181818",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M2.9668 10.4961V15.4979C2.9668 18.3273 2.9668 19.742 3.84548 20.621C4.72416 21.5001 6.13837 21.5001 8.9668 21.5001H14.9668C17.7952 21.5001 19.2094 21.5001 20.0881 20.621C20.9668 19.742 20.9668 18.3273 20.9668 15.4979V10.4961",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M14.9668 16.9932C14.2827 17.6004 13.1936 17.9932 11.9668 17.9932C10.74 17.9932 9.65089 17.6004 8.9668 16.9932",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M10.1038 8.41848C9.82182 9.43688 8.79628 11.1936 6.84777 11.4482C5.12733 11.673 3.82246 10.922 3.48916 10.608C3.12168 10.3534 2.28416 9.53872 2.07906 9.02952C1.87395 8.52032 2.11324 7.41706 2.28416 6.96726L2.96743 4.98888C3.13423 4.49196 3.5247 3.31666 3.92501 2.91913C4.32533 2.5216 5.13581 2.5043 5.4694 2.5043H12.4749C14.2781 2.52978 18.2209 2.48822 19.0003 2.50431C19.7797 2.52039 20.2481 3.17373 20.3848 3.45379C21.5477 6.27061 22 7.88382 22 8.57124C21.8482 9.30456 21.22 10.6873 19.0003 11.2955C16.6933 11.9275 15.3854 10.6981 14.9751 10.2261M9.15522 10.2261C9.47997 10.625 10.4987 11.4279 11.9754 11.4482C13.4522 11.4686 14.7273 10.4383 15.1802 9.92062C15.3084 9.76786 15.5853 9.31467 15.8725 8.41848",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1))
const _hoisted_28 = { class: "label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isUserRoleSuperAdministrator)
        ? (_openBlock(), _createBlock(_component_el_menu, {
            key: 0,
            onSelect: _ctx.setRoute
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "AdministrationSuperAdministratorDashboardIndex" }, {
                title: _withCtx(() => [
                  _hoisted_3,
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.translation.dashboard), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "AdministrationSuperAdministratorUsersIndex" }, {
                title: _withCtx(() => [
                  _hoisted_5,
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.translation.users), 1)
                ]),
                _: 1
              }),
              _createElementVNode("span", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.translation.shop), 1)
              ]),
              _createVNode(_component_el_menu_item, { index: "AdministrationSuperAdministratorShopOrdersIndex" }, {
                title: _withCtx(() => [
                  _hoisted_9,
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.translation.orders), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "AdministrationSuperAdministratorShopShopsIndex" }, {
                title: _withCtx(() => [
                  _hoisted_11,
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.translation.shops), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "AdministrationSuperAdministratorShopCouponsIndex" }, {
                title: _withCtx(() => [
                  _hoisted_13,
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.translation.coupons), 1)
                ]),
                _: 1
              }),
              _createElementVNode("span", _hoisted_15, [
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.translation.settings), 1)
              ]),
              _createVNode(_component_el_menu_item, { index: "AdministrationSuperAdministratorSettingsCurrenciesIndex" }, {
                title: _withCtx(() => [
                  _hoisted_17,
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.translation.currencies), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "AdministrationSuperAdministratorSettingsProductCategoriesIndex" }, {
                title: _withCtx(() => [
                  _hoisted_19,
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.translation.productCategories), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onSelect"]))
        : _createCommentVNode("", true),
      (_ctx.isUserRoleAdministrator)
        ? (_openBlock(), _createBlock(_component_el_menu, {
            key: 1,
            onSelect: _ctx.setRoute
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "AdministrationAdministratorDashboardIndex" }, {
                title: _withCtx(() => [
                  _hoisted_21,
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.translation.dashboard), 1)
                ]),
                _: 1
              }),
              _createElementVNode("span", _hoisted_23, [
                _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.translation.shop), 1)
              ]),
              _createVNode(_component_el_menu_item, { index: "AdministrationAdministratorShopOrdersIndex" }, {
                title: _withCtx(() => [
                  _hoisted_25,
                  _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.translation.orders), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "AdministrationAdministratorShopShopsIndex" }, {
                title: _withCtx(() => [
                  _hoisted_27,
                  _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.translation.shops), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onSelect"]))
        : _createCommentVNode("", true)
    ])
  ]))
}